import {
  CoverageSearchModal as HyperCoverageSearchModal,
  OrganizationProvider,
} from '@hologram-hyper-dashboard/components';
import useAppSelector from 'common-js/hooks/useAppSelector';
import { getSelectedOrg } from 'common-js/reducers/organization/selectors';
import { Plan } from 'common-js/types/Plan';
import { FC } from 'react';

interface CoverageSearchModalProps {
  legacyPlan?: Plan;
  onClose: () => void;
}

const CoverageSearchModal: FC<CoverageSearchModalProps> = ({ legacyPlan, onClose }) => {
  const selectedOrg = useAppSelector(getSelectedOrg);
  return (
    <OrganizationProvider organizationId={selectedOrg?.id}>
      <HyperCoverageSearchModal
        legacyPlan={legacyPlan}
        onClose={onClose}
        className="HyperDashboardModal"
        defaultOpen
      />
    </OrganizationProvider>
  );
};
export default CoverageSearchModal;
